import { useState, useEffect } from "react"
import { useUpdateCourseMutation, useDeleteCourseMutation } from "./coursesApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"

const EditCourseForm = ({ course }) => {

    const {  isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateCourse, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateCourseMutation()

    const [deleteCourse, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteCourseMutation()

    const navigate = useNavigate()

    const [name, setName] = useState(course.name)
    const [active, setActive] = useState(course.active)

    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setName('')
            navigate(`/${type}/${groupId}/courses`)
        }

    }, [isSuccess, isDelSuccess, navigate])



    const canSave = [name].every(Boolean) && !isLoading

    const onSaveCourseClicked = async (e) => {
        if (canSave) {
            await updateCourse({ id: course.id,name, active })
        }
    }

    const onDeleteCourseClicked = async () => {
        await deleteCourse({ id: course.id })
    }
   

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validTitleClass = !name ? "form__input--incomplete" : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteCourseClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Course </h2>
                    <div className="form__action-buttons">
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveCourseClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                        <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/courses`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="course-name">
                    Name:</label>
                <input
                    className={`form__input ${validTitleClass}`}
                    id="course-name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                />

               
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="course-active">
                            ACTIVE:
                            <input
                                className="form__checkbox"
                                id="course-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={e => setActive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>
            </form>
        </>
    )

    return content
}

export default EditCourseForm